import { Link } from 'react-router-dom';
import type { MouseEvent, ReactNode } from 'react';
import { useApiKeyStatus } from '@/features/research/useApiKeyStatus';
import { gammaGate } from '@/features/research/apiKeyGating';
import { ApiKeyDisabledNote } from '@/features/research/ApiKeyNotices';

export function useGammaTearsheetGate() {
  const { testResults, isVerifying } = useApiKeyStatus();
  return gammaGate(testResults, isVerifying);
}

/** Inline note under Generate / Request tearsheet actions. */
export function TearsheetGammaNotice() {
  const gate = useGammaTearsheetGate();
  return <ApiKeyDisabledNote reason={gate.reason} keyName="gamma_api_key" />;
}

/** Link that starts a new tearsheet — disabled with the Gamma message when the key is missing. */
export function TearsheetGenerateLink({
  to,
  className,
  title,
  children,
  target,
  rel,
  onClick,
  'data-testid': testId,
}: {
  to: string;
  className?: string;
  title?: string;
  children: ReactNode;
  target?: string;
  rel?: string;
  onClick?: (e: MouseEvent) => void;
  'data-testid'?: string;
}) {
  const gate = useGammaTearsheetGate();
  if (gate.disabled) {
    return (
      <span
        className={className}
        title={gate.reason}
        role="note"
        data-testid={testId}
        style={{ opacity: 0.55, cursor: 'not-allowed', pointerEvents: 'none' }}
      >
        {children}
      </span>
    );
  }
  return (
    <Link
      to={to}
      className={className}
      title={title}
      target={target}
      rel={rel}
      onClick={onClick}
      data-testid={testId}
    >
      {children}
    </Link>
  );
}
